export const EVENT_TYPES = {
  ON_READY: 'onEmbeddedMessagingReady',
  ON_TOKEN_EXPIRED: 'onEmbeddedMessagingIdentityTokenExpired',
};
